<template>
<div>
  <div class="breadcrumb-list">
    <ol class="breadcrumb">
      <li class="breadcrumb-item active">Activities</li>
    </ol>
  </div>
  <div class="attendance-report">

  </div>
</div>
</template>
<script>
import moment from 'moment';
export default {
  components: {

    },
  data() {
    return {

    }
  },

  created() {

  },
  mounted() {

  },
  methods: {}
}
</script>
<style scoped>



</style>
